<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <em class="boton_observaciones sombraModales" v-b-tooltip.hover.v-light.topright="'Comentarios de la cita'" @click="obtenerCitaObservaciones()"></em>
    <div class="modal-movil" v-bind:class="{ 'div-centrado': esMovil}" v-if="mostrarInformacion"  :style="{ width: width + 'vh', height: height + 'vh', right: 50+'%', top: !esMovil?'0vh': '0', right: !esMovil?'0vh': '0'}" >
      <div class="row d-flex justify-content-between m-1" style="font-weight: bolder;">
        <div>
        </div>
        <div>
          <em class="close_x_svg"  style="float: right; height: 12px; cursor: pointer" @click="cerrarModal()"></em>
        </div>
      </div>
      <div class="mb-1 d-flex justify-content-center text-center">
        <div class="m-2" style=" height: 10vh; width: 56vh;">
          <em class="patient_profile"></em>
          <p  v-if="pacienteSeleccionado != null" class="mt-1" style="top: 0px; left: 0px; font-weight: 600; font-size: .9em;">{{pacienteSeleccionado.nombrePaciente}}</p>
          <hr style="width: 80%;">
        </div>
      </div>
      <div v-if="loading" class="d-flex justify-content-center align-items-center mt-5">
        <div class="your-div">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
      <p v-if="pacienteSeleccionado != null" class="mt-5 ml-3 text-left" style=" font-weight: 600; font-size: .9em; color: #0F95AA">Observaciones del paciente</p>
      <div v-if="pacienteSeleccionado != null && pacienteSeleccionado.observaciones.length > 0" class="div-scroll">
        <div v-for="(comentario, index) in pacienteSeleccionado.observaciones" v-bind:key="index">
          <div class="text-left mt-3 ml-3 mr-3">
            <div class="d-flex">
              <p class="mr-1" style="font-size: .7em; margin-bottom: 0px; color: #6E6E6E !important;">{{comentario.usuarioAlta}}</p>
              <p style="font-size: .7em; margin-bottom: 0px; color: #6E6E6E !important;">{{comentario.fechaAlta | formatoFecha}}</p>
            </div>
            <div style="background-color: #F9F9F9; box-shadow: 0px 0px 1.5px 0px rgba(0, 0, 0, 0.32); min-height: 3em; padding: 2%; border-radius: 10px;">
              <p style="font-size: .8em;">{{comentario.observacion}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && pacienteSeleccionado === null " class="d-flex justify-content-center align-items-center">
        <b-alert show variant="info"><strong>Actualmente, no contamos con comentarios previos.</strong></b-alert>
      </div>
      <div  v-if="pacienteSeleccionado != null && pacienteSeleccionado.idCita != null && !diagInicial" class="d-flex mb-4 ml-2" style="bottom: 10px; position: absolute; width: 95%; margin-left: -5px;">
        <b-form-input
            placeholder="Escribe un nuevo comentario"
            v-model="comentarioNuevo"
            style="width: 96%;"
        >
        </b-form-input>
        <b-button size="sm" variant="outline-info" @click="agregarObservacion()" :disabled="comentarioNuevo === null || comentarioNuevo === ''">
                          <span
                          ><em class="send_comments" style="height: 16px; margin-top: 8%; margin-bottom: -3px;"></em
                          ></span>
        </b-button>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  export default {
    name: "ObservacionesCita",
    props: {
      idCita:Number,
      diagInicial: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
        pacienteSeleccionado: null,
        comentarioNuevo: null,
        mostrarInformacion: false,
        x: 0,
        y: 0,
        width: 78,
        height: 100,
        esMovil:false,
        loading: false
      }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
      this.esMovil = this.detectarDispositivoMovil()
     if(this.esMovil){
       this.x = -29;
       this.left = -21;
       this.width = 43;
       this.height = 81;
     }
    },
    methods: {
      obtenerCitaObservaciones(){
        this.pacienteSeleccionado = null;
        this.mostrarInformacion = true;
        this.loading = true;
        const parametros = {
          idCita: this.idCita
        }
        this.$http.post(this.$api + "agenda/obtenerCitaObservaciones", parametros).then((response) => {
          if(response.data.data.idCita !== null){
            this.pacienteSeleccionado = response.data.data;
          }
          if(this.esMovil){
            this.x = -29;
            this.left = -21;
            this.width = 43;
            this.height = 81;
          }
        }).catch((error) => {
          console.error("Error al obtener la informacion:", error);
        })
            .finally(() => {
              this.loading = false;
            });
      },
      detectarDispositivoMovil() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  
        // Dispositivos móviles
        if (/android/i.test(userAgent)) {
          return true;
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return true;
        }
  
        // Si no es ninguno de los anteriores, asumimos que es un PC
        return false;
      },
      async agregarObservacion(){
        this.pacienteSeleccionado = null;
        this.loading = true;
        const datosParaGuardar = {
          idCita: this.idCita,
          observaciones: this.comentarioNuevo
        };
  
        this.$http.post(this.$api + 'agenda/agregarObservacionCita', datosParaGuardar)
            .then(async () => {
              this.$swal.fire({
                icon: 'success',
                text: "Se guardó la observación correctamente",
                showConfirmButton: false,
                timer: 1500,
              });
  
              this.comentarioNuevo = "";
              this.obtenerCitaObservaciones();
  
            })
            .catch(async (error) => {
              console.error("Error al guardar:", error);
              this.$swal.fire({
                icon: 'error',
                text: "Ocurrió un error, por favor inténtelo más tarde",
                showConfirmButton: false,
                timer: 1500,
              });
            })
         .finally(() => {
          this.loading = false;
          })
      },
      cerrarModal(){
        if(this.esMovil){
          this.x = -29;
          this.left = -21;
          this.width = 43;
          this.height = 81;
        }else{
          this.x = 0;
          this.y =0;
          this.width = 78;
          this.height = 100;
        }
        this.pacienteSeleccionado= null;
        this.comentarioNuevo = null;
        this.mostrarInformacion = false;
        this.loading = false;
      }
    }
  }
  </script>
  
  <style scoped>
    .sombraModales {
      filter: drop-shadow(2px 1px 4px rgba(0, 0, 0, 0.25));
    }

  .icono-herramienta{
    border-radius: 49%;
    -webkit-box-shadow: 0px 10px 10px -6px black;
    box-shadow: 0px 10px 10px -6px black;
    background: #88D487 !important;
    border-color: #88D487 !important;
  }
  .modal-movil {
    position: fixed;
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px;
    -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }
  .div-centrado {
    position: absolute;
    top: 210%;
    left: 1%;
    transform: translate(-50%, -50%);
  }
  .div-scroll{
    width: 100%;
    height: 73%;
    overflow: auto;
  }
  </style>
  